import React from 'react';
import { Button, CircularProgress } from '@mui/material';
import './PaymentSummary.css';

interface PaymentSummaryProps {
  totalAmount: number;
  paidAmount: number;
  balanceAmount: number;
  onSubmit?: () => void;
  submitButtonText?: string;
  isSubmitDisabled?: boolean;
  isLoading?: boolean; // New prop for loading state
}

const PaymentSummary: React.FC<PaymentSummaryProps> = ({
  totalAmount,
  paidAmount,
  balanceAmount,
  onSubmit,
  submitButtonText = 'Submit',
  isSubmitDisabled = false,
  isLoading = false, // Default to false
}) => {
  const formatAmount = (amount: number): string => {
    return amount.toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  return (
    <div className="payment-summary-container">
      <div className="payment-summary-details">
        <div className="payment-summary-row">
          <span className="payment-summary-label">Total Amount :</span>
          <span className="payment-summary-value">{formatAmount(totalAmount)}</span>
        </div>
        <div className="payment-summary-row">
          <span className="payment-summary-label">Paid Amount :</span>
          <span className="payment-summary-value">{formatAmount(paidAmount)}</span>
        </div>
        <div className="payment-summary-row">
          <span className="payment-summary-label">Balance Amount :</span>
          <span className="payment-summary-value">{formatAmount(balanceAmount)}</span>
        </div>
      </div>

      <div className="payment-summary-actions">
        <Button
          variant="contained"
          disabled={isSubmitDisabled || isLoading}
          onClick={onSubmit}
          startIcon={isLoading ? <CircularProgress size={16} color="inherit" /> : null}
          sx={{
            textTransform: 'none',
            minWidth: '115px',
            backgroundColor: 'var(--dashboard-theme-color)',
            boxShadow: 'none',
            '&:hover': {
              boxShadow: 'none',
              background: 'var(--dashboard-theme-color)',
            },
            '&:disabled': {
              backgroundColor: '#ccc',
              color: '#666',
            },
          }}
        >
          {isLoading ? 'Processing...' : submitButtonText}
        </Button>
      </div>
    </div>
  );
};

export default PaymentSummary;